// eslint-disable-next-line no-restricted-imports -- original import from react-i18next to wrap
import { useTranslation } from "react-i18next";
import { type I18nTFunctionBound } from "@/types/customTypes";

export function useCommonTranslation() {
  const { t } = useTranslation();

  return {
    t: t as I18nTFunctionBound,
  };
}
